import { PromptProps, PromptTypes } from "./types"
import { Alert } from "~/ui/primitives"
import { debug } from "~utils"

export const editPrompt = ({
  title = "提示",
  message = "保存本次编辑?",
  onClose,
  onSuccess,
  onCancel,
}: PromptProps): void => {
  debug(`[PROMPT][${PromptTypes.EDIT}]: `, message)
  Alert.alert(
    title,
    message,
    [
      {
        text: "不保存",
        onClick: onCancel,
        style: "destructive",
      },
      { text: "保存", onClick: onSuccess },
    ],
    {
      cancelable: true,
      onDismiss: onClose,
    },
  )
}

export const prompt = ({
  title = "提示",
  message = "",
  onClose,
  onSuccess,
  onCancel,
  successText = "确定",
  cancelText = "取消",
}: PromptProps): void => {
  debug(`[PROMPT][${PromptTypes.NORMAL}]: `, message)
  Alert.alert(
    title,
    message,
    [
      {
        text: cancelText,
        onClick: onCancel,
        style: "destructive",
      },
      { text: successText, onClick: onSuccess, style: "default" },
    ],
    {
      cancelable: true,
      onDismiss: onClose,
    },
  )
}

export const promptSingle = ({
  title = "提示",
  message = "",
  onClose,
  onSuccess,
  successText = "确定",
}: PromptProps): void => {
  debug(`[PROMPT][${PromptTypes.NORMAL}]: `, message)
  Alert.alert(title, message, [{ text: successText, onClick: onSuccess, style: "default" }], {
    cancelable: true,
    onDismiss: onClose,
  })
}
